/**
 * Single source of truth for splitting a text element's content into render lines.
 *
 * Every renderer (HTML, gradient SVG, curved SVG, thumbnail SVG, thumbnail HTML)
 * must route through this helper so multi-line text stays byte-identical across
 * paths. Empty lines are preserved — splitting "A\n\nB" returns ["A", "", "B"]
 * so blank lines render with the correct vertical spacing.
 *
 * Does NOT trim, collapse whitespace, or mutate characters. The output is the
 * input minus the line-break delimiter.
 *
 * @param {string} text - The raw text content (may be empty/undefined).
 * @returns {string[]} - One entry per visual line, in order.
 */
export function getTextLines(text = '') {
  return String(text)
    .replace(/\r\n/g, '\n')
    .split('\n');
}
